// extracted by mini-css-extract-plugin
export default {"editableBlocked":"TextBlock_editableBlocked__7khdE","editableInline":"TextBlock_editableInline__unp0I","editablePlainText":"TextBlock_editablePlainText__nWR2o"};